import { getConfig } from '@data-delivery/permission-ui-shared-environment';
import SplunkOtelWeb from '@splunk/otel-web';
import SplunkSessionRecorder from '@splunk/otel-web-session-recorder';

export const initializeSplunkRum = () => {
  const config = getConfig();
  SplunkOtelWeb.init({
    realm: 'us0',
    rumAccessToken: config.RUM_ACCESS_TOKEN,
    applicationName: 'SFTP Permissioning UI',
    deploymentEnvironment: config.VITE_ENVIRONMENT,
  });
};

export const initSessionRecorder = () => {
  const config = getConfig();
  SplunkSessionRecorder.init({
    realm: 'us0',
    rumAccessToken: config.RUM_ACCESS_TOKEN,
  });
};
